import React, { useState, useEffect, useContext } from 'react'
import classNames from 'classnames'
import AskVisoThinking from '../layout/AskVisoThinking'
import ModalCheckbox from 'components/ModalCheckbox'
import Comment from '../../../Comment/index'
import AskVisoChatMessage from './AskVisoChatMessage'
import AskVisoCreateCharts from '../forms/AskVisoCreateCharts'
import AskVisoCreateDemo from '../forms/AskVisoCreateDemo'
import { deleteMessage } from '../../../../api/ai-agents'
import { handleMutation } from '../../../../utils/request'
import { defaultNotifier } from 'functions/notificationHandler'
import { SlidePanelScrollContext } from 'components/SlidePanel'
import '../../../../screens/Incidents/IncidentAnalytics/charts/style.scss'
import './AskVisoChat.scss'

const AskVisoChat = ({
  messages = [], color, isLoading, toggleLoading, setMessages, setPromptValue, chatId, isFullscreen, devicesData, workspace,toggleReloadDataOnClose, dashboardDetails, mode, metricsData, setContentBuildingInput, activeContent, showForm, onAskAgent
}) => {
  const [deleteModal, setDeleteModal] = useState('')
  const { scrollToBottom } = useContext(SlidePanelScrollContext)

  useEffect(() => {
    typeof requestAnimationFrame === 'function'
      ? requestAnimationFrame(() => scrollToBottom())
      : setTimeout(() => scrollToBottom(), 50)
  }, [messages, isLoading, scrollToBottom, isFullscreen])

  const onDeleteMessage = async (messageId) => {
    toggleLoading(true)
    const onSuccess = () => {
      defaultNotifier('Message deleted successfully')
      setMessages(messages.filter((item) => item._id !== messageId))
    }

    try {
      const response = await deleteMessage({ id: messageId })
      handleMutation(response, onSuccess)
    } catch (error) {
      defaultNotifier(error)
    } finally {
      setDeleteModal('')
      toggleLoading(false)
    }
  }

  return (
    <div className={classNames('ask-viso-chat', isFullscreen && 'ask-viso-chat--fullscreen')}>
      {mode?.[0]?.value === 'autoBuildCharts' &&
        <AskVisoCreateCharts
          metricsData={metricsData}
          color={color}
          isLoading={isLoading}
          dashboardDetails={dashboardDetails}
          isFullscreen={isFullscreen}
          mode={mode}
          setDashboardBuildingInput={setContentBuildingInput}
          setPromptValue={setPromptValue}
        />
      }
      {activeContent === 'demoAppBuilding' && showForm &&
        <AskVisoCreateDemo
          color={color}
          isLoading={isLoading}
          isFullscreen={isFullscreen}
          setPromptValue={setPromptValue}
          setDemoBuildingInput={setContentBuildingInput}
        />
      }
      {messages.length > 0 && messages.map((item, index) =>
        <AskVisoChatMessage
          key={`${item.senderRole}-${item.createdAt}-${index}`}
          message={item}
          setDeleteModal={setDeleteModal}
          isFullscreen={isFullscreen}
          chatId={chatId}
          setPromptValue={setPromptValue}
          color={color}
          devicesData={devicesData}
          toggleReloadDataOnClose={toggleReloadDataOnClose}
          dashboardDetails={dashboardDetails}
          modeValue={mode?.[0]?.value}
          onAskAgent={onAskAgent}
          workspace={workspace}
        />
      )}
      {isLoading &&
        <div className='ask-viso__loading'>
          <Comment
            contentClass={'ask-viso-chat__comment'}
            hideName
            firstName='A'
            lastName='I'
            color={color}
            text={
              <>
                <div className='ask-viso-chat__thinking'></div>
                <AskVisoThinking color={color} />
              </>
            }
          />
        </div>
      }
      {deleteModal &&
        <ModalCheckbox
          title='Remove Message'
          color={color}
          confirmMessage='You are about to permanently remove this message.'
          onClose={() => setDeleteModal('')}
          onConfirm={deleteModal ? () => onDeleteMessage(deleteModal) : null}
          hideCheckBox
          confirmText='Delete'
          confirmColor='danger'
        />
      }
    </div>
  )
}

export default AskVisoChat